import 'css-chunksrc/client/scenes/inviteMembers/member/styles.scss';export default {
  "member": "_member_o182j_1",
  "row": "_row_o182j_8",
  "group": "_group_o182j_19",
  "label": "_label_o182j_23",
  "input": "_input_o182j_29",
  "error": "_error_o182j_52",
  "failed": "_failed_o182j_58"
};